export const selectIdentity = (state) => state.identity;

export const isApiCallLoading = (state, requestType) =>
  state.loading[requestType];

export const selectFocusedRequest = (state, id) => {
  const toApproveRequest = state.requests.toApprove.find((r) => r.id === id);
  return {
    request: toApproveRequest || state.requests.my.find((r) => r.id === id),
    toApprove: !!toApproveRequest,
  };
};

export const selectBreadcrumbs = (state) => {
  return state.breadcrumbs.nav;
};
